<template>
  <div class="d-flex" :class="spacing ? `my-${spacing}` : ''">
    <i class="fa" v-bind:class="classes" :aria-hidden="true"></i>
    <div class="flex-grow-1 pl-1">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fa: {
      type: String,
      required: false,
      default: null
    },
    fa_size: {
      type: Number,
      required: false,
      default: 2
    },
    spacing: {
      type: Number,
      required: false,
      default: 3
    }
  },
  computed: {
    classes() {
      return `fa-fw ${this.fa} fa-${this.fa_size}x`;
    }
  }
};
</script>

<style lang="css" scoped>
.flex-grow-1 {
  flex-grow: 1;
}
</style>
